import classNames from 'classnames';

import { thousandSeparated } from 'shared/util/formatting';
import { scrollToElementById } from '@/utils/scroll';
import { focusElementById } from '@/utils/focus';
import type { HotelOffer } from '@/interfaces';
import { trackBestOffer } from '@/utils/tracking/finnAnalytics';

export interface BestOfferDetailsProps {
    offer?: HotelOffer;
    nights: number;
    numberOfAdults: number;
    numberOfChildren: number;
    noPanel?: boolean;
    className?: string;
}

const travellersAndStayText = (nights: number, adults: number, children: number): string => {
    const nightsText = nights !== 1 ? `${nights} netter` : `${nights} natt`;
    const adultsText = adults !== 1 ? `${adults} voksne` : `${adults} voksen`;

    if (children > 0) {
        const childrenText = `${children} barn`;
        return `${nightsText}, ${adultsText}, ${childrenText}`;
    }
    return `${nightsText}, ${adultsText}`;
};

export const BestOfferDetails = ({ offer, nights, numberOfAdults, numberOfChildren, noPanel = false }: BestOfferDetailsProps) => {
    const onClick = (): void => {
        trackBestOffer();
        scrollToElementById('offersList');
        focusElementById('offersList');
    };
    if (!offer) {
        return null;
    }
    const inner = (
        <>
            <div
                data-testid="offer-details"
                className={classNames('grid__unit u-hide-lt300', {
                    'u-hide-gt768 u-size1of2 u-text-right flex flex-column-reverse': noPanel,
                    'u-size1of1 u-text-center': !noPanel,
                })}>
                <div className={classNames('u-mb4', { 'u-d1': noPanel })}>
                    {travellersAndStayText(nights, numberOfAdults, numberOfChildren)}
                    {!noPanel && ', fra'}
                </div>
                <div className={classNames('u-strong', { 'u-t1': !noPanel, 'u-t3 u-mb8': noPanel })}>
                    {noPanel && 'fra '}
                    {thousandSeparated(offer.totalRate)} kr
                </div>
            </div>
            <button
                type="button"
                data-testid="best-offer-button"
                className={classNames('grid__unit button button--order u-size1of1 u-mt16', { 'u-hide-gt768': noPanel })}
                onClick={onClick}>
                Se tilbud og priser
            </button>
        </>
    );
    return noPanel ? inner : <div className="panel panel--info u-mr0 u-mt0">{inner}</div>;
};
